module.exports = __webpack_public_path__ + "static/img/3b53ec0e775147f52b05ec472a0aa052.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_zfsb.png
// module id = 14PY
// module chunks = 1